import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is synthetic data?",
      answer: "Synthetic data is artificially generated data that mimics real-world data while maintaining the same statistical properties. It's created using algorithms and models rather than being collected from real-world events or measurements."
    },
    {
      question: "Why use synthetic data instead of real data?",
      answer: "Synthetic data offers several advantages: privacy protection (no real personal data), cost-effectiveness (cheaper than collecting real data), availability (can generate as much as needed), and control (can create specific scenarios or edge cases)."
    },
    {
      question: "Is synthetic data as good as real data?",
      answer: "When properly generated, synthetic data can be just as effective as real data for many applications. However, it depends on the quality of the generation process and the specific use case. Some applications may still require real data for validation."
    },
    {
      question: "What types of data can be generated synthetically?",
      answer: "You can generate various types of data including: text data, numerical data, time series data, images, audio, and structured data like tables. The type of data depends on the generation model and requirements."
    },
    // {
    //   question: "How do you ensure the quality of synthetic data?",
    //   answer: "Quality is ensured through: statistical validation, domain expert review, comparison with real data distributions, testing on specific use cases, and continuous monitoring of the generation process."
    // },
    {
      question: "What are the main applications of synthetic data?",
      answer: "Common applications include: AI/ML model training, data privacy protection, software testing, research and development, data augmentation, and creating training environments for various industries."
    },
    // {
    //   question: "Is synthetic data safe to use?",
    //   answer: "Yes, when properly generated and validated. However, it's important to: understand the limitations of your synthetic data, validate it against real-world scenarios, and ensure it meets the requirements of your specific use case."
    // },
    // {
    //   question: "How much synthetic data do I need?",
    //   answer: "The amount needed depends on: your specific use case, the complexity of the patterns you're trying to capture, the diversity required, and the quality of the data. It's often better to start with a smaller, high-quality dataset and expand as needed."
    // }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="py-16 bg-gradient-to-br from-blue-50 via-indigo-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-blue-600 mb-12">
          Frequently Asked Questions
        </h2>
        <div className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <div key={index} className="mb-4">
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full text-left p-4 bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 flex justify-between items-center"
              >
                <span className="font-semibold text-gray-800">{faq.question}</span>
                {openIndex === index ? (
                  <ChevronUp className="h-5 w-5 text-blue-600" />
                ) : (
                  <ChevronDown className="h-5 w-5 text-blue-600" />
                )}
              </button>
              {openIndex === index && (
                <div className="p-4 bg-white rounded-lg shadow-md mt-2 text-gray-600">
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FAQSection; 